import { Component, OnDestroy, OnInit } from '@angular/core';
import { EOtpremniceClient, IVozacFazeDto, PromenaVozilaCommand } from '@kodit/core/data-api';
import { FormGroupTypeSafe } from 'angular-typesafe-reactive-forms-helper';
import { Subscription } from 'rxjs';
import { EotpremnicaFormService } from '../../otpremnice/eotpremnica-form.service';
import { DynamicDialogConfig, DynamicDialogRef } from '@kodit/core/shared-ui';
import { FormHelper } from '@kodit/core/form-definitions';
import { AlertService, SharedService } from '@kodit/core/services';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'kodit-promena-vozila-form',
  templateUrl: './promena-vozila-form.component.html',
  styleUrls: ['./promena-vozila-form.component.scss']
})
export class PromenaVozilaFormComponent implements OnInit, OnDestroy {

  private _subs: Subscription = new Subscription();

  /** Props */
  form: FormGroupTypeSafe<IVozacFazeDto>;

  constructor(
    private _fs: EotpremnicaFormService,
    private _client: EOtpremniceClient,
    public _dialogRef: DynamicDialogRef,
    public _dialogConfig: DynamicDialogConfig,
    private _formHelper: FormHelper,
    private _sharedService: SharedService,
    private _alert: AlertService,
  ) { }

  ngOnInit(): void {
    this._subs.add(
      this._client
        .getVozacInicijalneFaze(this._dialogConfig?.data.otpremnicaId)
        .subscribe((res) => {
          this.form = this._fs.getVozacFazeFormGroup(res.data);
        })
    );

    this._subs.add(
      this._dialogRef.onSubmit.subscribe(() => {
        this.save();
      })
    );
  }

  save() {
    if (!this.form.valid) {
      this._formHelper.invalidateForm(this.form);
      return;
    }

    const command = {
      otpremnicaId: this._dialogConfig?.data.otpremnicaId,
      vozacFazeDto: this.form?.value
    };

    this._sharedService.displayLoadingScreen(true, "Promena vozila u toku");
    this._subs.add(
      this._client
        .promenaVozila(command as PromenaVozilaCommand)
        .pipe(
          finalize(() => {
            this._sharedService.resetLoadingScreen();
          })
        )
        .subscribe((res) => {
          if(res.succeeded){
            this._alert.addSuccessMsg(res.messages[0]);
            this._dialogRef.close(true);
            return;
          }
          this._dialogRef.close(true);
          this._alert.addFailedMsg(res.messages[0]);
        })
    );

  }

  ngOnDestroy(): void {
    this._subs.unsubscribe();
  }

}
